<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col></b-col>
        <b-col lg="4" class="p-3 mt-5">
        <b-modal id="modal-leave" centered title="Unallowed Exit" ok ok-variant="success" hide-cancel>
            <template v-slot:modal-ok> Continue </template>
            <p>Sorry you cannot exit at this point. Please proceed to the testhall.</p>
        </b-modal>
          <b-overlay :show="false" spinner-variant="primary">
            <b-card class="start-card p-4 text-center">
              <div class="">
                <b-avatar size="6rem" :src="details.profileimage"></b-avatar>
                <p class="p-2">
                  <span class="ffn">{{ details.fullname }}</span> <br>  <span class="ffl">{{ details.email }}</span>
                </p>
                
                
                <p>
                  <span class="ffb">{{ start_config.structure == 'Section' ? start_config.institution_shortname : start_config.title }}</span>
                </p>

                <p class="ffb" v-if="start_config.course">
                    {{ start_config.course }}
                </p>

                <b-badge
                  variant="success"
                  v-for="subject in start_config.subjects"
                  :key="subject"
                  class="p-2 m-2 subtext"
                >
                  {{ subject }}
                </b-badge>

                <p class="m-3">
                  <span class="ffl">{{ start_config.mode }} Mode</span>
                </p>
                <p class="gtime m-3">
                  <span class="rtime">{{ start_config.total_time / 60 }}Mins</span>
                </p>
                <b-badge
                  :style="{ 'background-color' : '#243057' }"
                  class="p-2 m-2 subtext"
                >
                  {{ start_config.totalquestions }} Questions
                </b-badge>

                <b-overlay
                  :show="starting"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class=""
                >
                  <b-button :disabled="starting" class="btn-md p-3 mt-5" @click="start">
                    Start Test
                  </b-button>
                </b-overlay>
              </div>
            </b-card>
          </b-overlay>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import NProgress from "nprogress";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      starting: false,
    };
  },
  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "select",
      });
    }

    if (this.started) {
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: JSON.parse(this.start_config.category).name,
          institution : this.start_config.institution_shortname
        },
      });
    }

    if (this.submitted == true) {
      this.$router.push({
        name: "select",
      });
    }
  },
  beforeRouteLeave(to, from, next) {
          
      if(to.name != 'testhall'){
          this.$bvModal.show("modal-leave");
          next(false);
      }else{
        next()
      }
      
  },
  beforeRouteEnter(to, from, next) {
    //NProgress.start();
    next();
    //NProgress.done();
  },
  methods: {
    ...mapActions("exam", ["starttest"]),

    start() {
      this.starting = false;
      this.$store.dispatch("exam/startTest");

      if (this.started) {
        this.$router.push({
          name: "testhall",
          params: {
            trackid: this.start_config.track_id,
            category: JSON.parse(this.start_config.category).name,
            institution : this.start_config.institution_shortname
          },
        });
      }
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      start_config: (state) => state.exam.start_config,
      started: (state) => state.exam.started,
      submitted: (state) => state.exam.submitted,
    }),
  },
};
</script>

<style scoped>
.subtext {
  color: white;
  font-size: 20px;
  font-weight: bold;
}

.gtime {
  font-weight: bold;
  font-size: 20px;
}

.rtime {
  font-size: 1.7rem;
  font-weight: bolder;
  font-family: "Times New Roman", Times, serif;
}

.btn-md {
  color: white;
  font-weight: bold;
  font-size: 1rem;
  background-color:  #00984A;
  border : 0px;
  border-radius: 10px 10px;
  width: 120px;
}

.btn-md:hover {
  background-color: #243057;
}

.ffn {
  font-size: 1.5rem;
  font-weight : bold;
}

.ffl {
  font-size: 1.1rem;
  font-weight: normal
}

.ffb {
  font-size: 1.4rem;
  font-weight: bolder;
  margin-right: 10px;
}

.ffbb {
  background-color: #00377b;
}

.ffbw {
  color: #00377b;
}


@media (max-width: 768px) {

}
</style>
